import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.string.trim-end.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { _nullishCoalesce } from '@sentry/utils/esm/buildPolyfills';
import { getCurrentHub } from '@sentry/hub';
import { logger, getSentryBaggageItems, dropUndefinedKeys } from '@sentry/utils';
import { Span, SpanRecorder } from './span.js';
/** JSDoc */

var Transaction = /*#__PURE__*/function (_Span) {
  _inherits(Transaction, _Span);

  var _super = _createSuper(Transaction);

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function Transaction(transactionContext, hub) {
    var _this;

    _classCallCheck(this, Transaction);

    _this = _super.call(this, transactionContext);

    Transaction.prototype.__init.call(_assertThisInitialized(_this));

    ;
    _this._hub = hub || getCurrentHub();
    _this.name = transactionContext.name || '';
    _this.metadata = transactionContext.metadata || {};
    _this._trimEnd = transactionContext.trimEnd; // this is because transactions are also spans, and spans have a transaction pointer

    _this.transaction = _assertThisInitialized(_this);
    return _this;
  }
  /**
   * JSDoc
   */


  _createClass(Transaction, [{
    key: "__init",
    value:
    /**
     * The reference to the current hub.
     */
    function __init() {
      this._measurements = {};
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this.name = name;
    }
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */

  }, {
    key: "initSpanRecorder",
    value: function initSpanRecorder() {
      var maxlen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      if (!this.spanRecorder) {
        this.spanRecorder = new SpanRecorder(maxlen);
      }

      this.spanRecorder.add(this);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setMeasurement",
    value: function setMeasurement(name, value) {
      var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this._measurements[name] = {
        value: value,
        unit: unit
      };
    }
    /**
     * Set metadata for this transaction.
     * @hidden
     */

  }, {
    key: "setMetadata",
    value: function setMetadata(newMetadata) {
      this.metadata = _objectSpread(_objectSpread({}, this.metadata), newMetadata);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "finish",
    value: function finish(endTimestamp) {
      var _this2 = this;

      // This transaction is already finished, so we should not flush it again.
      if (this.endTimestamp !== undefined) {
        return undefined;
      }

      if (!this.name) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
        this.name = '<unlabeled transaction>';
      } // just sets the end timestamp


      _get(_getPrototypeOf(Transaction.prototype), "finish", this).call(this, endTimestamp);

      if (this.sampled !== true) {
        // At this point if `sampled !== true` we want to discard the transaction.
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

        var client = this._hub.getClient();

        if (client) {
          client.recordDroppedEvent('sample_rate', 'transaction');
        }

        return undefined;
      }

      var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) {
        return s !== _this2 && s.endTimestamp;
      }) : [];

      if (this._trimEnd && finishedSpans.length > 0) {
        this.endTimestamp = finishedSpans.reduce(function (prev, current) {
          if (prev.endTimestamp && current.endTimestamp) {
            return prev.endTimestamp > current.endTimestamp ? prev : current;
          }

          return prev;
        }).endTimestamp;
      }

      var transaction = {
        contexts: {
          trace: this.getTraceContext(),
          baggage: getSentryBaggageItems(this.getBaggage())
        },
        spans: finishedSpans,
        start_timestamp: this.startTimestamp,
        tags: this.tags,
        timestamp: this.endTimestamp,
        transaction: this.name,
        type: 'transaction',
        sdkProcessingMetadata: this.metadata
      };
      var hasMeasurements = Object.keys(this._measurements).length > 0;

      if (hasMeasurements) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
        transaction.measurements = this._measurements;
      }

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Tracing] Finishing ".concat(this.op, " transaction: ").concat(this.name, "."));
      return this._hub.captureEvent(transaction);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toContext",
    value: function toContext() {
      var spanContext = _get(_getPrototypeOf(Transaction.prototype), "toContext", this).call(this);

      return dropUndefinedKeys(_objectSpread(_objectSpread({}, spanContext), {}, {
        name: this.name,
        trimEnd: this._trimEnd
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "updateWithContext",
    value: function updateWithContext(transactionContext) {
      _get(_getPrototypeOf(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);

      this.name = _nullishCoalesce(transactionContext.name, function () {
        return '';
      });
      this._trimEnd = transactionContext.trimEnd;
      return this;
    }
  }]);

  return Transaction;
}(Span);

export { Transaction };